/**
 * Tutorial guidato dell'elenco Documenti.
 *
 * I tre pallini della riga si raccontano illuminando il pulsante e non il menu che
 * aprono: un menu di Vuetify aperto dal tutorial si richiude da solo, perche' il click
 * programmatico e quello su "Avanti" arrivano a `document` a un soffio di distanza.
 * Il tutorial non preme il piu': porterebbe via dalla pagina.
 *
 * Chi ha il ruolo in sola lettura non vede il piu' ne' il filtro destinatario: il passo
 * del piu' si salta da solo.
 */
const SCOPE = '[data-tour-scope="documents"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createDocumentsTourSteps() {
	return [
		{
			body: "Qui si consegnano documenti alle persone che hanno un accesso al gestionale: buste paga, contratti, moduli. Il file resta nel gestionale e il destinatario se lo scarica da solo, senza passare da una mail con l'allegato.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I documenti',
		},
		{
			body: "I filtri stanno sopra l'elenco: il periodo di riferimento - utile per ritrovare le buste paga di un mese - il destinatario e se il documento e' gia' stato scaricato. Restano nell'indirizzo della pagina: un refresh, o il ritorno da una scheda, li ritrova come li avevi lasciati.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Filtrare i documenti',
		},
		{
			body: "Il piu' in alto apre la pagina per consegnare un documento nuovo: destinatario, tipo di documento e file da allegare. La pagina ha un tutorial suo, e Annulla riporta qui.",
			key: 'add',
			missing: 'skip',
			placement: 'left',
			target: at('add'),
			title: 'Consegnare un documento',
		},
		{
			body: "La tabella mostra la data di invio, il nome del documento, chi l'ha mandato, chi deve riceverlo e se e' stato scaricato. Una riga per destinatario: lo stesso documento mandato a piu' persone occupa piu' righe.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "Questa colonna dice se il destinatario ha scaricato il file, con giorno e ora: verde scaricato, rossa ancora no. Per una busta paga o un documento da firmare e' la prova che e' stato ritirato.",
			key: 'downloaded',
			placement: 'left',
			target: at('downloaded'),
			title: 'Chi ha scaricato e quando',
		},
		{
			body: "I tre pallini a inizio riga raccolgono le azioni del documento: Modifica apre la sua pagina, Elimina lo cancella con il file allegato, dopo una conferma. Chi ha il ruolo in sola lettura trova invece Visualizza e Scarica: e' da li' che il destinatario prende il suo documento, ed e' quel gesto a far scattare la data di scaricamento.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Aprire o scaricare',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
